// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import VueCookies from 'vue-cookies'
import store from "./store/";
import router from "./router";
import VueI18n from "vue-i18n";
import VueMq from 'vue-mq';
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, numeric, double, email, max_value, min_value, min, max } from 'vee-validate/dist/rules';
import SvgIcon from "@/components/SvgIcon";
import * as Filters from "@/filters";

import { defaultLocale, languages } from "./locales/index.js";
import axios from "axios";

Vue.config.productionTip = false;

Vue.use(VueI18n);
Vue.use(VueCookies)

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    mobile: 900,
    desktop: Infinity,
  },
  defaultBreakpoint: 'desktop' // customize this for SSR
})

const messages = Object.assign(languages);

export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: "fr",
  messages
});

extend("required", {
  ...required,
  message: field => i18n.t('validation.errors.required')
});

extend("alpha", {
  validate(value) {
    return value.match("^[a-zA-Z \\-àáâäçèéêëìíîïñòóôöùúûü'.]*$")
  },
  message: (_, values) => i18n.t('validation.errors.alpha')
})

extend("min", {
  ...min,
  message: (_, values) => i18n.t('validation.errors.min')
});

extend("max", {
  ...max,
  message: (_, params, values) => i18n.tc('validation.errors.max', params.length)
});

extend("numeric", {
  ...numeric,
  message: field => i18n.t('validation.errors.numeric')
});

extend("min_value", {
  ...min_value,
  message: field => i18n.t('validation.errors.min_value')
});

extend("max_value", {
  ...max_value,
  message: field => i18n.t('validation.errors.max_value')
});

extend("commaFloatNumber", {
  validate(value, { min = null, max = null } = {}) {
    value = value.replace(',', '.');
    const minPart = JSON.parse(min) !== null ? value >= parseFloat(min) : true;
    const maxPart = JSON.parse(max) !== null ? value <= parseFloat(max) : true;
    return !isNaN(parseFloat(value)) && isFinite(value) && minPart && maxPart;
    },
  params: ['min', 'max'],
  message: (_, values) => {
    if(JSON.parse(values.min) && JSON.parse(values.max))
      return i18n.t('validation.errors.commaFloatNumberMinMax', {min: values.min, max: values.max});
    else if(JSON.parse(values.min))
      return i18n.t('validation.errors.commaFloatNumberMin', {min: values.min});
    else if(JSON.parse(values.max))
      return i18n.t('validation.errors.commaFloatNumberMax', {max: values.max});
    else
      return i18n.t('validation.errors.commaFloatNumber')
  }
})

extend("specialchars", {
  validate(value) {
    let regex = new RegExp("^[^<>'=!?`´+~%]+$");
    return regex.test(value)
  },
  message: field => i18n.t('validation.errors.email')
});

extend("email", {
  ...email,
  message: field => i18n.t('validation.errors.email')
});

extend("noemail", {
  validate(value) {
    return value !== 'noemail@mega.be';
  },
  message: (_, values) => i18n.t('validation.errors.noemail')
});

extend("be_phone", {
  validate(value) {
    return value.match("^(0032\\s?|0)4(5[56]|60|[6789]\\d)(\\s?\\d{2}){3}$|^((\\+|00|)32\\s?|0)(\\d(\s)?\\d{3}|\\d{2}(\s)?\\d{2})((\\s)?\\d{2}){2}$") && parseInt(value) > 0;
  },
  message: (_, values) => i18n.t('validation.errors.phone')
});

extend("international_phone", {
  validate(value) {
    return value.match("^((00|\\+)(32|33|352|34|31|39|41|44|48|49)[1-9]\\d{7,10}|(0[1-9]\\d{6,8}))$");
  },
  message: (_, values) => i18n.t('validation.errors.phone')
});

extend("noSupplied", {
  async validate(value) {
    //console.log(router.currentRoute.query['agent'])
    return store.state.calculation.area !== 'bx' || router.currentRoute.query['agent'] === 'AG000045';
  },
  message: (_, values) => i18n.t('validation.errors.no_supplied')
})

extend('consumptionAmount', {
  async validate(value) {
    return value < 100000
  },
  message: (_, values) => i18n.t('validation.errors.highAmount', {max: 100000})
})

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("SvgIcon", SvgIcon);

Vue.mixin({
  filters: Filters
});

let errorCodes = [401, 405, 408, 409, 413, 422, 429, 500, 502, 503, 504];
export function  addInterceptor() {
  axios.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    if (errorCodes.includes(error.response.status)) {
      router.push({ name: "ServerError" });
    }
    throw error;
  });
}

addInterceptor();

export function removeInterceptor() {
  axios.interceptors.request.eject(interceptor)
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js